// removed by extract-text-webpack-plugin
module.exports = {"vadpLoginRoot":"vadpLoginRoot___19cvV","logoDiv":"logoDiv___2Ti0O","logo":"logo___eUvth","nameDiv":"nameDiv___39GrX","nameCn":"nameCn___1KWmO","nameEn":"nameEn___3qPPf","right":"right___3cdIR","rightImage":"rightImage___OZMpn","image":"image___3C7nt","bottom":"bottom___1C8ZM","span":"span___1GiCO","company":"company___3Cmwk","license":"license___knOtm","licenseTitle":"licenseTitle___3mVTy","licenseScroll":"licenseScroll___2yewW","licenseText":"licenseText___3B_fS","licenseTextName":"licenseTextName___Iiac-","licenseTextDate":"licenseTextDate___S8m_v","vadpLoginDark":"vadpLoginDark___2ZFpE"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/LoginPageForNew/index.less
// module id = 309
// module chunks = 0